import { AIDE_URL } from '@/common/const/env'
import { AIDE_KEY } from '@/services/aide-bridge.service'

/** 构建 iframe 嵌入助手云端版的 URL；语言/主题通过 aide:sync 下发 */
export function buildAideUrl (): string {
  const url = new URL(AIDE_URL.endsWith('/') ? AIDE_URL : `${AIDE_URL}/`)

  url.pathname = '/chat'
  url.searchParams.set('aide', '1')
  url.searchParams.set('aideKey', AIDE_KEY.DUBATEAM)

  return url.toString()
}
